import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {PatientExtended} from '@/features/patients/types'
import {HttpChangePatientOptions, HttpChangePatientPayload, httpChangePatientStatus} from './patients.http'

export const useChangePatientStatus = ({
    urlParams,
    params,
    options
}: {
    urlParams: HttpChangePatientOptions['urlParams']
    params: HttpChangePatientOptions['params']
    options?: UseMutationOptions<
        AxiosResponse<PatientExtended>,
        AxiosError<{errors: {field: string}[]}>,
        HttpChangePatientPayload
    >
}) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CHANGE_PATIENT_STATUS],
        mutationFn: payload => httpChangePatientStatus({urlParams, params, payload})
    })
}
